/* Settings > Role updates (ADR 0031). Tokens only. */

.decision {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
}

.code {
  color: var(--graphite);
  font: var(--t-small);
}
